import { styled, Box } from '@mui/material';

export const StyledBox = styled(Box)(({ theme }) => ({
    width: '100%',
    border: '1px solid grey',
    borderRadius: '10px',
    overflow: 'hidden',
    color: 'white', // Set the text color to white
    backgroundColor: 'rgba(19, 21, 23, 1)',
    '&:focus-within': {
        border: `1px solid rgba(251, 188, 85, 1)`, // Set the border to yellow on focus
    },
}));
